// extracted by mini-css-extract-plugin
module.exports = {"text-row":"a10a3f92e9--text-row--H8LR0","buttons":"a10a3f92e9--buttons--WtfaV"};